/**
 * Side-by-side distribution tables. They stack once the page is narrow.
 */
import { el } from '../../core/dom.js';
import { button } from '../button.js';
import { csvFilename, csvMatrix, downloadCsv } from './csv.js';
import { renderDataTable } from './data-table.js';
import { resolvedOf } from './shape.js';

function groupRows(group) {
  return (group.rows || []).map((row) => ({
    label: row.label && typeof row.label === 'object' ? row.label : { text: row.label, raw: row.raw },
    count: row.count && typeof row.count === 'object' ? row.count : { text: row.count, value: row.count },
    share: { text: row.percentText != null ? String(row.percentText) : (row.share != null ? String(row.share) : '') },
  }));
}

/**
 * @param {object} block
 * @param {{ onAsk?: Function }} [actions]
 * @returns {HTMLElement}
 */
export function renderBreakdown(block, actions) {
  const data = resolvedOf(block);
  const title = data.title ? String(data.title) : '';
  const groups = Array.isArray(data.groups) ? data.groups.slice(0, 4) : [];
  const base = data.baseLabel ? el('p', { class: 'chat-caption' }, String(data.baseLabel)) : null;
  const multi = data.multiSelect ? el('p', { class: 'chat-note' }, 'Can select more than one') : null;
  const grid = el('div', { class: 'chat-break' });
  const flat = [];
  groups.forEach((group) => {
    const rows = groupRows(group);
    rows.forEach((row) => flat.push({ group: { text: group.title || '' }, ...row }));
    grid.append(renderDataTable({
      type: 'breakdown',
      id: `${(block && block.id) || 'g'}-${group.title || flat.length}`,
      title: group.title || '',
      columns: [
        { key: 'label', label: 'Label', wrap: true },
        { key: 'count', label: 'Count', format: 'number' },
        { key: 'share', label: 'Share', format: 'percent' },
      ],
      rows,
      sortable: true,
      nested: true,
      csv: false,
      actions,
      askTitle: group.title || title,
    }));
  });
  const columns = [
    { key: 'group', label: 'Group' },
    { key: 'label', label: 'Label' },
    { key: 'count', label: 'Count' },
    { key: 'share', label: 'Share' },
  ];
  const tools = el('div', { class: 'chat-block-tools' },
    title ? el('h3', { class: 'chat-block-title' }, title) : null,
    button('Download CSV', {
      className: 'chat-tool',
      onClick: () => downloadCsv(csvFilename(title || 'breakdown'), csvMatrix(columns, flat)),
    }));
  return el('section', {
    class: 'chat-block chat-block-breakdown-grid',
    'data-block-type': 'breakdown-grid',
    'data-block-id': (block && block.id) || '',
    'aria-label': title || 'Breakdown',
  }, tools, base, multi, grid);
}
